export function revealEmail() {
  const emailAddress = 'info@vinecliff1871.com';
  const revealEmailItems = document.querySelectorAll('.js-reveal-email');

  revealEmailItems.forEach((item) => {
    const button = document.createElement('button');
    item.parentNode.insertBefore(button, item);
    button.appendChild(item);

    button.addEventListener('click', (e) => {
      e.preventDefault();
      const link = document.createElement("a");

      link.href = `mailto:${emailAddress}`;
      link.textContent = emailAddress;

      button.insertAdjacentElement("afterend", link);
      link.focus();
      button.remove();
    });
  });
}
